module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "warp"
  }, [_c('el-col', {
    staticClass: "warp-breadcrum",
    attrs: {
      "span": 24
    }
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_c('b', [_vm._v("首页")])]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("用户列表")])], 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "warp-main",
    attrs: {
      "span": 24,
      "element-loading-text": "拼命加载中"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticStyle: {
      "min-width": "240px"
    },
    attrs: {
      "placeholder": "姓名"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSearch($event)
      }
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showAddDialog
    }
  }, [_vm._v("添加")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.users,
      "highlight-current-row": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "60",
      "fixed": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": "用户名",
      "width": "120",
      "fixed": "left",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "realName",
      "label": "姓名",
      "width": "120",
      "fixed": "left",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nickName",
      "label": "昵称",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sex",
      "label": "性别",
      "width": "100",
      "formatter": _vm.formatSex,
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "certType",
      "label": "证件类型",
      "width": "120",
      "formatter": _vm.formatCertType,
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "certNo",
      "label": "证件号码",
      "width": "180",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mobile",
      "label": "手机号",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "email",
      "label": "邮箱",
      "min-width": "160",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "birth",
      "label": "出生日期",
      "min-width": "160",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "户口地",
      "min-width": "180",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "liveAddress",
      "label": "居住地",
      "min-width": "180",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "headPicUrl",
      "label": "头像",
      "min-width": "180",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "状态",
      "formatter": _vm.formatStatus,
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.showEditDialog(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), (scope.row.orgId != '0') ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.removeUser(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "page-sizes": [10, 20, 50, 100],
      "page-size": 10,
      "background": "",
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增",
      "visible": _vm.addFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "80px",
      "rules": _vm.addFormRules
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "所属机构",
      "prop": "userName"
    }
  }, [_c('TreeSelect', {
    ref: "addtreeSelect",
    attrs: {
      "props": _vm.props,
      "options": _vm.orgs,
      "value": _vm.valueId,
      "clearable": _vm.isClearable,
      "accordion": _vm.isAccordion
    },
    on: {
      "getValue": function($event) {
        return _vm.getValue($event)
      }
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "用户名",
      "prop": "userName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.check_zh($event)
      }
    },
    model: {
      value: (_vm.addForm.userName),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "userName", $$v)
      },
      expression: "addForm.userName"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "密码",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "show-password": "",
      "auto-complete": "new-password"
    },
    model: {
      value: (_vm.addForm.password),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "password", $$v)
      },
      expression: "addForm.password"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "姓名",
      "prop": "realName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.realName),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "realName", $$v)
      },
      expression: "addForm.realName"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "昵称",
      "prop": "nickName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.nickName),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "nickName", $$v)
      },
      expression: "addForm.nickName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "证件类型",
      "prop": "certType"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addForm.certType),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "certType", $$v)
      },
      expression: "addForm.certType"
    }
  }, _vm._l((_vm.dictCertType), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "证件号码",
      "prop": "certNo"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.certNo),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "certNo", $$v)
      },
      expression: "addForm.certNo"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "性别",
      "prop": "sex"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addForm.sex),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "sex", $$v)
      },
      expression: "addForm.sex"
    }
  }, _vm._l((_vm.dictSex), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "出生日期",
      "prop": "birth"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "出生日期"
    },
    model: {
      value: (_vm.addForm.birth),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "birth", $$v)
      },
      expression: "addForm.birth"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "手机号",
      "prop": "mobile"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.mobile),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "mobile", $$v)
      },
      expression: "addForm.mobile"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "邮箱",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "email",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.email),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "email", $$v)
      },
      expression: "addForm.email"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "户口地址",
      "prop": "address"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.address),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "address", $$v)
      },
      expression: "addForm.address"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "居住地址",
      "prop": "liveAddress"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.liveAddress),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "liveAddress", $$v)
      },
      expression: "addForm.liveAddress"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_c('el-form-item', {
    attrs: {
      "label": "用户状态",
      "prop": "roleIds"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addForm.status),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "status", $$v)
      },
      expression: "addForm.status"
    }
  }, _vm._l((_vm.dictStatus), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "label": "角色",
      "prop": "roleIds",
      "width": "300px"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "collapse-tags": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addForm.roles),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "roles", $$v)
      },
      expression: "addForm.roles"
    }
  }, _vm._l((_vm.roles), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.roleName,
        "value": item.id
      }
    })
  }), 1)], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑",
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "80px",
      "rules": _vm.addFormRules
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "所属机构",
      "prop": "userName"
    }
  }, [_c('TreeSelect', {
    ref: "treeSelect",
    attrs: {
      "props": _vm.props,
      "options": _vm.orgs,
      "value": _vm.valueId,
      "clearable": _vm.isClearable,
      "accordion": _vm.isAccordion
    },
    on: {
      "getValue": function($event) {
        return _vm.getValue($event)
      }
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "用户名",
      "prop": "userName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.check_zh($event)
      }
    },
    model: {
      value: (_vm.addForm.userName),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "userName", $$v)
      },
      expression: "addForm.userName"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "密码"
    }
  }, [_c('el-input', {
    attrs: {
      "show-password": "",
      "auto-complete": "new-password"
    },
    model: {
      value: (_vm.addForm.password),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "password", $$v)
      },
      expression: "addForm.password"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "姓名",
      "prop": "realName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.realName),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "realName", $$v)
      },
      expression: "addForm.realName"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "昵称",
      "prop": "nickName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.nickName),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "nickName", $$v)
      },
      expression: "addForm.nickName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "证件类型",
      "prop": "certType"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addForm.certType),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "certType", $$v)
      },
      expression: "addForm.certType"
    }
  }, _vm._l((_vm.dictCertType), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "证件号码",
      "prop": "certNo"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.certNo),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "certNo", $$v)
      },
      expression: "addForm.certNo"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "性别",
      "prop": "sex"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addForm.sex),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "sex", $$v)
      },
      expression: "addForm.sex"
    }
  }, _vm._l((_vm.dictSex), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "出生日期",
      "prop": "birth"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "出生日期"
    },
    model: {
      value: (_vm.addForm.birth),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "birth", $$v)
      },
      expression: "addForm.birth"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "手机号",
      "prop": "mobile"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.mobile),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "mobile", $$v)
      },
      expression: "addForm.mobile"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "邮箱",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "email",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.email),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "email", $$v)
      },
      expression: "addForm.email"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "户口地址",
      "prop": "address"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.address),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "address", $$v)
      },
      expression: "addForm.address"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "居住地址",
      "prop": "liveAddress"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.liveAddress),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "liveAddress", $$v)
      },
      expression: "addForm.liveAddress"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_c('el-form-item', {
    attrs: {
      "label": "用户状态",
      "prop": "roleIds"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addForm.status),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "status", $$v)
      },
      expression: "addForm.status"
    }
  }, _vm._l((_vm.dictStatus), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "label": "角色",
      "prop": "roleIds",
      "width": "300px"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "collapse-tags": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addForm.roles),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "roles", $$v)
      },
      expression: "addForm.roles"
    }
  }, _vm._l((_vm.roles), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.roleName,
        "value": item.id
      }
    })
  }), 1)], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bf2522d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/list.vue
// module id = 1159
// module chunks = 2